// @ts-check

// @ts-ignore
define(() => {
    "use strict";

    /**
     * @typedef ExperienceSize
     * @type {Object}
     * @property {Number} width
     * @property {Number} height
     */

    /**
     * Align all of the widgets to the left according to the scene or selection
     *
     * @param {Object[]} widgets
     * @param {Number} leftPosition
     * @param {ExperienceSize} experienceSize
     */
    function alignLeft(widgets, leftPosition, experienceSize) {
        widgets.forEach(({boundingBox, rect, model}) => {
            const originOffset      = rect.left - boundingBox.left;
            const offsetFromScene   = ((originOffset + leftPosition) / experienceSize.width) * 100;

            model.set("left", offsetFromScene, {render: true});
        });
    }


    /**
     * Align all of the widgets to the center(Horizontal axis) according to the scene or selection
     *
     * @param {Object[]} widgets
     * @param {Number} centerPosition
     * @param {ExperienceSize} experienceSize
     */
    function alignCenter(widgets, centerPosition, experienceSize) {
        widgets.forEach(({boundingBox, rect, model}) => {
            // eslint-disable-next-line no-mixed-operators
            const originOffset      = rect.left - (boundingBox.left + (boundingBox.right - boundingBox.left) / 2);
            const offsetFromScene   = ((originOffset + centerPosition) / experienceSize.width) * 100;

            model.set("left", offsetFromScene, {render: true});
        });
    }

    /**
     * Align all of the widgets to the right according to the scene or selection
     *
     * @param {Object[]} widgets
     * @param {Number} rightPosition
     * @param {ExperienceSize} experienceSize
     */
    function alignRight(widgets, rightPosition, experienceSize) {
        widgets.forEach(({boundingBox, rect, model}) => {
            const originOffset      = boundingBox.right - rect.left;
            const offsetFromScene   = ((rightPosition - originOffset) / experienceSize.width) * 100;

            model.set("left", offsetFromScene, {render: true});
        });
    }

    /**
     * Align all of the widgets to the top according to the scene or selection
     *
     * @param {Object[]} widgets
     * @param {Number} topPostion
     * @param {ExperienceSize} experienceSize
     */
    function alignTop(widgets, topPosition, experienceSize) {
        widgets.forEach(({boundingBox, rect, model}) => {
            const originOffset      = Math.abs(boundingBox.top - rect.top);
            const offsetFromScene   = ((originOffset + topPosition) / experienceSize.height) * 100;

            model.set("top", offsetFromScene, {render: true});
        });
    }

    /**
     * Align all of the widgets to the middle(Vertical Axis) according to the scene or selection
     *
     * @param {Object[]} widgets
     * @param {Number} middlePosition
     * @param {ExperienceSize} experienceSize
     */
    function alignMiddle(widgets, middlePosition, experienceSize) {
        widgets.forEach(({boundingBox, rect, model}) => {
            // eslint-disable-next-line no-mixed-operators
            const originOffset      = rect.top - (boundingBox.top + (boundingBox.bottom - boundingBox.top) / 2);
            const offsetFromScene   = ((originOffset + middlePosition) / experienceSize.height) * 100;

            model.set("top", offsetFromScene, {render: true});
        });
    }

    /**
     * Align all of the widgets to the bottom according to the scene or selection
     *
     * @param {Object[]} widgets
     * @param {Number} bottomPosition
     * @param {ExperienceSize} experienceSize
     */
    function alignBottom(widgets, bottomPosition, experienceSize) {
        widgets.forEach(({boundingBox, rect, model}) => {
            const originOffset      = boundingBox.bottom - rect.top;
            const offsetFromScene   = ((bottomPosition - originOffset) / experienceSize.height) * 100;

            model.set("top", offsetFromScene, {render: true});
        });
    }

    return {
        alignBottom,
        alignMiddle,
        alignTop,
        alignRight,
        alignCenter,
        alignLeft
    };
});



// WEBPACK FOOTER //
// ./src/editor/util/Alignment.js